<!--课程体系-->
<template>
	<div class="">
		<Header></Header>
		<van-row>
			<van-row class="Courdesystem w95">
               <div class="hotmain">
               	<div class="hotmainbox" v-for="(item,inidex) in classTypes" :key="inidex"  @click='openDetail(item.id)'>
               		<div class="horimg">
               			<img height="91px" :src="item.cover"
               			 alt="">
               		</div>
               		<div class="hottit">
               			<p>{{item.title}}</p>
               		</div>
               		<div class="hotinfo">
               			<span>查看详情</span><span><img src="../assets/home/lannest.png" alt=""></span>
               		</div>
               	</div>
               </div>	
			</van-row>
			<Fotter></Fotter>
		</van-row>
	</div>	
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import __Config from '../api/config';
	export default {
		name: 'Courdesystem',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
              classTypes:[]
			}

		},
		methods: {
          getclassTypes(){
                this.$toast.loading({
					duration: 0,  
					mask: true,
					message: '加载中...'
				});
                  var that = this;
			      this.$axios.get(__Config.api.getclassType,{

				})
				.then(function (res) {
					 that.$toast.clear();
				     that.classTypes = res.data.data;
			
				})
				.catch(function (err) {
					 that.$toast.clear();
					console.log(err);
				});
		  },

          openDetail(id){
			  this.$router.push({  
			 	name: 'Courdesystem_detail',  
			 	params: {   
			 		id: id   
			 	}  
			 	
			 })  
		  }
		},
		created(){
			this.getclassTypes();
		}
	}
</script>

<style scoped>
.Courdesystem{
	margin: 0 auto 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Courdesystem.vue